var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtlasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.701,
    height: 50.295,
    viewBox: "0 0 127.701 50.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AtlasPrimaryLogo",
    transform: "translate(21.778 -31.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16123",
    "data-name": "Group 16123",
    transform: "translate(-21.778 31.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16115",
    "data-name": "Group 16115",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16114",
    "data-name": "Group 16114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10676",
    "data-name": "Path 10676",
    d: "M89.772,112.756A4.756,4.756,0,1,1,85.016,108a4.756,4.756,0,0,1,4.756,4.756",
    transform: "translate(-64.805 -87.043)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10677",
    "data-name": "Path 10677",
    d: "M117.3,21.144,121.132.74,111.4,14.915Z",
    transform: "translate(-89.86 -0.74)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10678",
    "data-name": "Path 10678",
    d: "M149.115,146.7l-8.386-8.531-6.419,6.079Z",
    transform: "translate(-108.294 -111.318)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10679",
    "data-name": "Path 10679",
    d: "M57.656,163.26,54.51,181.8l9.42-11.915Z",
    transform: "translate(-44.086 -131.505)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10680",
    "data-name": "Path 10680",
    d: "M15.556,89.092,1.16,86.54l8.312,8.316Z",
    transform: "translate(-1.16 -69.776)",
    fill: "#114870"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16116",
    "data-name": "Group 16116",
    transform: "translate(5.541 8.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10681",
    "data-name": "Path 10681",
    d: "M152.572,116.771l2.984-2.8-6.536-.95Z",
    transform: "translate(-125.671 -99.317)",
    fill: "#d8ad1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10682",
    "data-name": "Path 10682",
    d: "M81.907,48.56,76.52,42.89,77.64,52.6Z",
    transform: "translate(-67.337 -42.89)",
    fill: "#d8ad1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10683",
    "data-name": "Path 10683",
    d: "M107.03,178.326l5.7,5.83-1.4-9.906Z",
    transform: "translate(-91.885 -148.584)",
    fill: "#d8ad1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10684",
    "data-name": "Path 10684",
    d: "M32.361,135.23,29.52,138.4l6.317.5Z",
    transform: "translate(-29.52 -117.188)",
    fill: "#d8ad1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16117",
    "data-name": "Group 16117",
    transform: "translate(8.951 14.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10685",
    "data-name": "Path 10685",
    d: "M141.931,117.348l-4.1-4.328-1.264,9.4Z",
    transform: "translate(-119.063 -105.603)",
    fill: "#e9d635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10686",
    "data-name": "Path 10686",
    d: "M83.6,79.4l9.75,1.108L88.19,75.06Z",
    transform: "translate(-76.443 -75.06)",
    fill: "#e9d635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10687",
    "data-name": "Path 10687",
    d: "M51.046,115.2l1.335-9.426-5.41,5.121Z",
    transform: "translate(-46.97 -99.77)",
    fill: "#e9d635"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10688",
    "data-name": "Path 10688",
    d: "M87.263,166.237,78.08,164.83l5.043,5.326Z",
    transform: "translate(-72.001 -147.29)",
    fill: "#e9d635"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16122",
    "data-name": "Group 16122",
    transform: "translate(23.28 43.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16119",
    "data-name": "Group 16119",
    transform: "translate(0.027 26.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16118",
    "data-name": "Group 16118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10689",
    "data-name": "Path 10689",
    d: "M149.01,338.37h5.5v1.155h-4.162v2H154.2v1.09h-3.851v2.235h4.236v1.155H149.01Z",
    transform: "translate(-149.01 -338.188)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10690",
    "data-name": "Path 10690",
    d: "M182.63,348.54h1.155v.813l.021.021a2,2,0,0,1,1.721-.985,1.739,1.739,0,0,1,1.958,1.884v3.8h-1.219v-3.476c-.031-.868-.354-1.241-1.081-1.241a1.348,1.348,0,0,0-1.336,1.454v3.263H182.63Z",
    transform: "translate(-176.061 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M213.909,351.622a1.472,1.472,0,0,0,1.487,1.637,1.276,1.276,0,0,0,1.348-.92H217.9a2.422,2.422,0,0,1-2.5,1.882,2.613,2.613,0,0,1-2.706-2.909,2.677,2.677,0,1,1,5.285.309h-4.066Zm2.847-.8a1.424,1.424,0,1,0-2.847,0Z",
    transform: "translate(-200.248 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M244.51,348.54h1.145v1.069h.021a1.8,1.8,0,0,1,1.616-1.219,2.711,2.711,0,0,1,.459.033V349.6a2.822,2.822,0,0,0-.524-.055c-.825,0-1.5.662-1.5,1.893v2.632h-1.219v-5.53Z",
    transform: "translate(-225.85 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10693",
    "data-name": "Path 10693",
    d: "M267.791,353.783c0,1.669-.963,2.481-2.716,2.481-1.112,0-2.352-.428-2.472-1.723h1.219c.15.7.705.813,1.327.813a1.251,1.251,0,0,0,1.422-1.413V353.1h-.021a1.893,1.893,0,0,1-1.659.973c-1.755,0-2.481-1.327-2.481-2.909a2.553,2.553,0,0,1,2.5-2.771,1.721,1.721,0,0,1,1.637.909h.021v-.76h1.219Zm-1.221-2.6c0-.953-.428-1.829-1.487-1.829-1.081,0-1.456,1.006-1.456,1.927,0,.9.438,1.829,1.456,1.829C266.165,353.109,266.57,352.136,266.57,351.182Z",
    transform: "translate(-240.253 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10694",
    "data-name": "Path 10694",
    d: "M293.12,349.16h1.336l1.444,4.129h.022l1.4-4.129h1.272l-2.149,5.828c-.4.995-.674,1.893-1.958,1.893a5.47,5.47,0,0,1-.844-.064v-1.026a3.662,3.662,0,0,0,.578.074c.557,0,.717-.3.856-.77l.139-.428Z",
    transform: "translate(-264.962 -346.87)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M339.754,342.713c0,1.167.868,1.637,1.936,1.637,1.176,0,1.616-.588,1.616-1.155a.909.909,0,0,0-.631-.942c-.545-.2-1.219-.342-2.278-.631a1.923,1.923,0,0,1-1.69-1.936c0-1.54,1.413-2.247,2.792-2.247,1.583,0,2.931.844,2.931,2.438h-1.336c-.074-.985-.717-1.348-1.647-1.348-.619,0-1.4.225-1.4.994,0,.545.363.823.909.985.117.031,1.807.471,2.2.588a2.024,2.024,0,0,1,1.487,1.946c0,1.712-1.53,2.4-3.038,2.4-1.743,0-3.156-.834-3.187-2.728h1.335Z",
    transform: "translate(-301.411 -337.44)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M374.05,351.3a2.795,2.795,0,1,1,2.792,2.921A2.681,2.681,0,0,1,374.05,351.3Zm4.365,0c0-.952-.481-1.946-1.573-1.946s-1.573.995-1.573,1.946.481,1.958,1.573,1.958S378.415,352.263,378.415,351.3Z",
    transform: "translate(-330.08 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M408,338.37h1.219v7.638H408Z",
    transform: "translate(-357.396 -338.188)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10698",
    "data-name": "Path 10698",
    d: "M425.877,354.689h-1.2v-.77h-.021a1.856,1.856,0,0,1-1.573.92c-1.456,0-2.065-.717-2.065-2.171V349.16h1.219v3.39c0,.973.385,1.327,1.059,1.327,1.016,0,1.358-.653,1.358-1.508V349.16h1.219v5.529Z",
    transform: "translate(-367.872 -346.87)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10699",
    "data-name": "Path 10699",
    d: "M449.61,342.329h.92V340.67h1.219v1.659h1.1v.909h-1.1v2.952c0,.5.043.76.588.76a2.075,2.075,0,0,0,.514-.043v.942a6.355,6.355,0,0,1-.791.065c-1.284,0-1.5-.492-1.53-1.411v-3.263h-.92Z",
    transform: "translate(-390.876 -340.039)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M470.85,338.37h1.219v1.155H470.85Zm0,2.108h1.219v5.529H470.85Z",
    transform: "translate(-407.966 -338.188)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M482.57,351.3a2.795,2.795,0,1,1,2.792,2.921A2.681,2.681,0,0,1,482.57,351.3Zm4.365,0c0-.952-.481-1.946-1.573-1.946s-1.573.995-1.573,1.946.481,1.958,1.573,1.958S486.935,352.263,486.935,351.3Z",
    transform: "translate(-417.396 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M516.35,348.54H517.5v.813l.022.021a2,2,0,0,1,1.721-.985,1.74,1.74,0,0,1,1.958,1.884v3.8h-1.219v-3.476c-.033-.868-.354-1.241-1.08-1.241a1.348,1.348,0,0,0-1.337,1.454v3.263H516.35Z",
    transform: "translate(-444.576 -346.25)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10703",
    "data-name": "Path 10703",
    d: "M547.461,352.3c.074.717.6.963,1.25.963.471,0,1.262-.1,1.231-.727s-.92-.717-1.807-.92-1.776-.514-1.776-1.637c0-1.209,1.305-1.583,2.309-1.583,1.133,0,2.171.459,2.312,1.7h-1.272c-.117-.588-.578-.739-1.123-.739-.354,0-1.006.086-1.006.567,0,.6.9.7,1.8.887s1.786.524,1.786,1.616c0,1.315-1.327,1.8-2.472,1.8-1.4,0-2.417-.619-2.45-1.925Z",
    transform: "translate(-468.626 -346.259)",
    fill: "#114870"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16121",
    "data-name": "Group 16121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16120",
    "data-name": "Group 16120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10704",
    "data-name": "Path 10704",
    d: "M157.409,203.24h6.981l8.443,23.185h-7.4l-.973-3.312h-7.37l-1.039,3.312H148.87Zm5.617,14.9L160.947,211h-.064l-2.241,7.143Z",
    transform: "translate(-148.87 -203.24)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10705",
    "data-name": "Path 10705",
    d: "M273.225,214.527h3.441v3.961h-3.441v5.879c0,1.559.324,2.241,1.981,2.241a11.15,11.15,0,0,0,1.461-.1v4.871c-1.3,0-2.728.2-4.125.2-2.728,0-5.746-.422-5.746-5.033v-8.052H263.94v-3.961H266.8V209.4h6.43v5.127Z",
    transform: "translate(-241.457 -208.196)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10706",
    "data-name": "Path 10706",
    d: "M340.2,203.24h6.43v23.185H340.2Z",
    transform: "translate(-302.816 -203.24)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10707",
    "data-name": "Path 10707",
    d: "M401.425,247a6.549,6.549,0,0,0,.78,3.767h-6.559a4.483,4.483,0,0,1-.227-1.59h-.064a6.882,6.882,0,0,1-5.422,2.013c-3.247,0-5.942-1.559-5.942-5.1,0-5.358,6.266-5.1,9.514-5.746.877-.162,1.753-.422,1.753-1.495,0-1.135-1.071-1.559-2.11-1.559-1.948,0-2.4,1.006-2.4,1.721h-5.975c.162-4.773,4.709-5.52,8.669-5.52,8.052,0,7.987,3.343,7.987,6.59V247Zm-6.17-3.8a12.824,12.824,0,0,1-2.532.811c-1.428.358-2.175.682-2.175,1.819a1.851,1.851,0,0,0,2.013,1.559,2.533,2.533,0,0,0,2.694-2.63Z",
    transform: "translate(-338.05 -227.579)",
    fill: "#114870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M495.6,238.814a1.629,1.629,0,0,0-.746-1.266,2.178,2.178,0,0,0-1.428-.487c-.911,0-1.948.227-1.948,1.3,0,.487.391.715.746.877,1.039.422,3.507.617,5.651,1.3,2.175.682,4.027,1.948,4.027,4.709,0,4.676-4.482,5.942-8.574,5.942-3.961,0-8.312-1.59-8.41-5.942h6.137a2.132,2.132,0,0,0,.78,1.493,2.537,2.537,0,0,0,1.721.486c.844,0,2.177-.324,2.177-1.3s-.551-1.266-3.54-1.786c-4.9-.811-6.884-2.4-6.884-5.293,0-4.254,4.578-5.358,7.954-5.358,3.636,0,8.021,1.006,8.183,5.324Z",
    transform: "translate(-419.259 -227.579)",
    fill: "#114870"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasLogo);
export default __webpack_public_path__ + "static/media/atlas_logo.390eba9ff043db403cb9a1225da8fecb.svg";
export { ForwardRef as ReactComponent };